import React from 'react';

const DropdownSkeleton = ({ widthClass }) => {
  const containerClasses = widthClass || 'w-full';

  return (
    <div className={`relative inline-block text-left ${containerClasses}`}>
      <div className="bg-gray-200 border border-gray-300 rounded-lg shadow-md px-4 py-2 mt-1 flex items-center justify-between w-full animate-pulse">
        <div className="h-4 bg-gray-300 rounded w-1/3"></div>
        <div className="w-5 h-5 ml-2 bg-gray-300 rounded"></div>
      </div>
    </div>
  );
};

export default DropdownSkeleton;
